import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Blocks from '../blocks/Blocks';
import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/about.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function About({ page = null }) {
    const { type = null, blocks = null } = page || {};
    return (
        <div className={classNames([styles.container, { [styles[type]]: type !== null }])}>
            <PageMeta page={page} />
            {blocks !== null && blocks.length > 0 ? (
                <Blocks className={styles.blocks} blockClassName={styles.block} blocks={blocks} />
            ) : null}
        </div>
    );
}

About.propTypes = propTypes;

export default About;
